import { Component, OnInit } from '@angular/core';
import { EspecializacaoService } from './service/especializacao.service';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { environment } from 'environments/environment';

const AREAS_CONHECIMENTO = [
  { nome: 'Humanas', key: 'humanas' },
  { nome: 'Exatas', key: 'exatas' },
  { nome: 'Saúde', key: 'saude' },
];

@Component({
  selector: 'cm-especializacao',
  templateUrl: './especializacao.component.html',
  styleUrls: ['./especializacao.component.scss']
})
export class EspecializacaoComponent implements OnInit {
  palavraChave
  listCurso
  nomesCurso
  cursosFiltrados
  filtrandoCursos = false
  environment = environment;
  carregandoCursosEspecializacao = true;
  cursosEspecializacao: Object[] = [];

  constructor(
    private especializacaoService: EspecializacaoService,
    private stringUtils: StringUtilsService
  ) { }

  ngOnInit() {
      this.especializacaoService.listCursoEspecializacao().subscribe(cursos => {
          let listCursoEspecializacao = this.cursosEspecializacao = cursos.cursosposgraduacao;

          listCursoEspecializacao.sort((a, b) => {
            const nameA = a.nome.toUpperCase();
            const nameB = b.nome.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            else if (nameA > nameB) {
              return 1;
            }

            return 0;
          });

          this.listCurso = listCursoEspecializacao

          this.cursosEspecializacao = listCursoEspecializacao.map(curso => {
            const link = this.gerarLinkCurso(curso);

            return { ...curso, link};
          });
          this.carregandoCursosEspecializacao = false;
      });
  }

  gerarLinkCurso(curso) {
    return `${curso.idWp}-${this.stringUtils.textoParaSlug(curso.nome)}`;
  }

  filtraCursosPorNome(value: string) {
    if (value.length > 0) {
      this.nomesCurso = this.listCurso.map(curso => curso)
      this.cursosFiltrados = this.nomesCurso.filter(curso => curso.nome.toLowerCase().includes(value.toLowerCase()))
      this.cursosEspecializacao = this.cursosFiltrados
    }
  }
}
